import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import FlipbookUltra from "./components/FlipbookUltra/FlipbookUltra";
import "./PageFlip.scss";

const PageFlip = () => {
  useEffect(() => {
    document.title = "Essentia Group Journal: Uma história em evolução";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Uma edição especial de 21 anos da história do Essentia Group. Conecte-se com a essência das nossas marcas.",
      );
    } else {
      const newMeta = document.createElement("meta");
      newMeta.name = "description";
      newMeta.content =
        "Uma edição especial de 21 anos da história do Essentia Group. Conecte-se com a essência das nossas marcas.";
      document.head.appendChild(newMeta);
    }
  }, []);

  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 6;

  return (
    <div className="pag_Journal">
      <div className="bloco01">
        <div className="container">
          <h1 className="seo-title">Essentia Group Journal</h1>
          <picture>
            <source
              media="(max-width: 767px)"
              srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/journal-mobile.png"
            />
            <img
              src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/journal.png"
              alt="Essentia Group Journal"
              className="mobile"
            />
          </picture>
          <div className="col-01">
            <span className="subtitle">EDIÇÃO ESPECIAL</span>
            <h2 className="seo-title-h2">Uma história em evolução</h2>
            <span className="numTitle">21 anos</span>
            <p>
              O <strong>Essentia Group Journal</strong> une passado e futuro por
              meio de uma história que continua sendo escrita. Conecte-se com a
              essência das nossas marcas, integradas pelo propósito de
              transformar ciência e inovação em cuidado real.
            </p>
          </div>
          <picture>
            <source
              media="(min-width: 768px)"
              srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/journal.png"
            />
            <img
              src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/journal.png"
              alt="Essentia Group Journal"
              className="desktop"
            />
          </picture>
        </div>
      </div>
      <div className="page-flip">
        <FlipbookUltra
          pdfUrl="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/Essentia_Group_Journal-b-compactado.pdf"
          title="Essentia Group Journal"
          desktopBreakpoint={900}
        />
      </div>
      <div className="bloco02">
        <div className="col-01">
          <h2>
            <em>21 anos</em> viraram notícia
          </h2>
          <p>
            Entre páginas, texturas e movimentos, o Essentia Group Journal ganha
            novas leituras — revelando, em cada imagem, a essência de uma
            história em constante evolução. <br />
            <br />
            <strong>
              Deslize para o lado e veja registros especiais da edição.
            </strong>
          </p>
        </div>
        <div className="col-02">
          <div className="carousel-fotos">
            <Slider
              ref={sliderRef}
              dots={false}
              infinite={true}
              speed={500}
              slidesToShow={1}
              slidesToScroll={1}
              arrows={false}
              beforeChange={(_, next) => setCurrentSlide(next)}
              responsive={[
                {
                  breakpoint: 768,
                  settings: {
                    centerMode: true,
                    centerPadding: "30px",
                    infinite: false,
                  },
                },
              ]}
            >
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-02.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-02-mobile.png"
                />
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-02.png"
                  alt="Imagem 2"
                />
              </picture>
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-03.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-03-mobile.png"
                />
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-03.png"
                  alt="Imagem 3"
                />
              </picture>
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-04.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-04-mobile.png"
                />
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-04.png"
                  alt="Imagem 4"
                />
              </picture>
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-05.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-05-mobile.png"
                />
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-05.png"
                  alt="Imagem 5"
                />
              </picture>
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-06.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-06-mobile.png"
                />
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-06.png"
                  alt="Imagem 6"
                />
              </picture>
              <picture>
                <source
                  media="(min-width: 768px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-01.png"
                />
                <source
                  media="(max-width: 767px)"
                  srcSet="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-01-mobile.png"
                />
                <img
                  src="https://essentialnutrition-upload-files.s3.us-east-1.amazonaws.com/site-essentiagroup/journal/img-01.png"
                  alt="Imagem 1"
                />
              </picture>
            </Slider>
            <div className="btNavCarousel">
              <button
                className="arrow-prev"
                onClick={() => sliderRef.current?.slickPrev()}
              >
                &#8249;
              </button>
              <ul className="custom-dots">
                {Array.from({ length: totalSlides }).map((_, i) => (
                  <li
                    key={i}
                    className={i === currentSlide ? "slick-active" : ""}
                  >
                    <button onClick={() => sliderRef.current?.slickGoTo(i)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
              <button
                className="arrow-next"
                onClick={() => sliderRef.current?.slickNext()}
              >
                &#8250;
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageFlip;
